export default "__VITE_ASSET__DkRnhTNd__"